// extracted by mini-css-extract-plugin
module.exports = {"root":"wODZZlsBSqvfrYnDbDVk","button":"HmOxV_bRE1Fr3Hs4J2f2","sideBySide":"SFio7LnGgkseQFPcGs_m"};